/**
 * AutoQA — the Enterprise offering on sentrodesk.com/pricing.
 *
 * Quality review runs inside the bot panel on Analytics. This page carries the
 * plan gate and routes an entitled tenant there.
 */

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AppLayout from "@/components/feature/AppLayout";
import FeatureLocked from "@/components/feature/FeatureLocked";
import { useEntitlements } from "@/contexts/EntitlementsContext";

export default function AutoQaPage() {
  const { hasFeature, loading } = useEntitlements();
  const navigate = useNavigate();
  const entitled = hasFeature("auto_qa");

  useEffect(() => {
    if (!loading && entitled) navigate("/analytics", { replace: true });
  }, [loading, entitled, navigate]);

  // A bare `null` while entitlements load reads as a dead click, so hold the
  // frame instead of blanking the screen.
  if (loading) {
    return (
      <AppLayout>
        <div className="flex min-h-[60vh] items-center justify-center text-sm text-slate-400">
          Loading…
        </div>
      </AppLayout>
    );
  }

  if (entitled) return null;

  return (
    <AppLayout>
      <FeatureLocked feature="auto_qa" />
    </AppLayout>
  );
}
